import { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import Flux from '../../../flux/Flux';
import Translations from '../../../utils/Translations';
import { VXPay, VXPayAction } from '../../../utils/VXPay';
import Tooltip from '../../Tooltip/Tooltip.js';
import Constants from '../../../flux/Constants.js';

class MediaPin extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isFavorite: this.props.initialIsFavorite,
		};
		this.onAlbumPinStatus = this.onAlbumPinStatus.bind(this);
		this.onPicturePinStatus = this.onPicturePinStatus.bind(this);
		this.onButtonClicked = this.onButtonClicked.bind(this);
		this.togglePin = this.togglePin.bind(this);

		this.tooltipRef = createRef();
	}

	componentDidMount() {
		if (this.props.pictureId) {
			Flux.Favorite.addPicturePinStatusListener(this.onPicturePinStatus);
		} else {
			if (!this.props.isSedcard) {
				Flux.Favorite.addAlbumPinStatusListener(this.onAlbumPinStatus);
			}
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.initialIsFavorite !== this.props.initialIsFavorite) {
			this.setState({
				isFavorite: this.props.initialIsFavorite,
			});
		}
	}

	componentWillUnmount() {
		if (this.props.albumId) {
			if (!this.props.isSedcard) {
				Flux.Favorite.removeAlbumPinStatusListener(this.onAlbumPinStatus);
			}
		} else if (this.props.pictureId) {
			Flux.Favorite.removePicturePinStatusListener(this.onPicturePinStatus);
		}
	}

	onAlbumPinStatus(albumId, status) {
		if (this.props.albumId && albumId === this.props.albumId) {
			this.setState({
				isFavorite: status,
			});
		}
	}

	onPicturePinStatus(pictureId, status) {
		if (this.props.pictureId && pictureId === this.props.pictureId) {
			this.setState({
				isFavorite: status,
			});
		}
	}

	togglePin() {
		if (this.props.pictureId) {
			if (this.state.isFavorite) {
				Flux.Favorite.unpinPicture(this.props.pictureId);
			} else {
				Flux.Favorite.pinPicture(this.props.pictureId);
			}
		} else {
			if (this.props.isSedcard) {
				if (this.props.isSedcardPinned) {
					Flux.Favorite.unpinSedcards(this.props.actorId);
				} else {
					Flux.Favorite.pinSedcards(this.props.actorId);
				}
			} else {
				if (this.state.isFavorite) {
					Flux.Favorite.unpinAlbum(this.props.albumId);
				} else {
					Flux.Favorite.pinAlbum(this.props.albumId);
				}
			}
		}

		this.setState({
			isFavorite: !this.state.isFavorite,
		});
	}

	onButtonClicked(e) {
		if (!Flux.Guest.isLoggedIn()) {
			let actionType, targetId;

			if (this.props.albumId) {
				actionType = Flux.Constants.ActionTypes.Notification.FAVORITE_PIN_ALBUM;
				targetId = this.props.albumId;
			} else if (this.props.pictureId) {
				actionType = Flux.Constants.ActionTypes.Notification.FAVORITE_PIN_PICTURE;
				targetId = this.props.pictureId;
			} else if (this.props.actorId) {
				actionType = Flux.Constants.ActionTypes.Notification.FAVORITE_PIN_SEDCARDS;
				targetId = this.props.actorId;
			}

			const action = new VXPayAction(actionType, {
				targetId: targetId,
			});
			VXPay.openSignupOrLogin({}, action);
		} else if (typeof this.props.onClickCallback === 'function') {
			this.props.onClickCallback();
		} else {
			this.togglePin();
		}
		if (e.preventDefault) {
			e.preventDefault();
		}

		if (typeof this.props.pinOnClickFn === 'function') {
			this.props.pinOnClickFn();
		}
	}

	render() {
		let classes = '';
		let title = '';
		let wrapperClasses = 'favorite-media-pin h-border-none h-background-none h-color-fg';

		if ((!this.props.isSedcard && this.state.isFavorite) || (this.props.isSedcard && this.props.isSedcardPinned)) {
			wrapperClasses += ' is-active';
			classes = 'icon -icon-pin-full';
			title = Translations.get('FavoriteMediaRemove');
		} else {
			classes = 'icon -icon-pin-line';
			title = Translations.get('FavoriteMediaAdd');
		}
		if (this.props.fontSize) {
			classes = classes + ' ' + this.props.fontSize;
		}

		if (!this.props.tooltipEnabled) {
			title = null;
		}

		const label = <i className={classes} />;

		return (
			<>
				<button className={wrapperClasses} onClick={this.onButtonClicked} ref={this.tooltipRef} aria-label={title}>
					{label}
				</button>
				<Tooltip targetRef={this.tooltipRef} position={this.props.tooltipPlacement} content={title} />
			</>
		);
	}
}

MediaPin.propTypes = {
	actorId: PropTypes.number,
	albumId: PropTypes.number,
	pictureId: PropTypes.number,
	initialIsFavorite: PropTypes.bool.isRequired,
	isSedcard: PropTypes.bool,
	isSedcardPinned: PropTypes.bool,
	onClickCallback: PropTypes.func,
	pinOnClickFn: PropTypes.func,
	fontSize: PropTypes.string,
	tooltipPlacement: PropTypes.oneOf(Object.values(Constants.Tooltip.place)),
	parentTileIndex: PropTypes.number,
	mediaType: PropTypes.string,
	tooltipEnabled: PropTypes.bool,
};

MediaPin.defaultProps = {
	tooltipPlacement: Constants.Tooltip.place.Bottom,
	tooltipEnabled: true,
};

export default MediaPin;
